import React from 'react'
import { View, StyleSheet, Animated, Easing } from 'react-native'
import theme from '../../../theme'

/**
 * WebSidebarSkeleton - Skeleton loader para el sidebar mientras carga el menú
 * Muestra placeholders animados con shimmer effect
 */
const WebSidebarSkeleton = ({ collapsed = false, itemCount = 4 }) => {
    const shimmerAnim = React.useRef(new Animated.Value(0)).current

    React.useEffect(() => {
        Animated.loop(
            Animated.sequence([
                Animated.timing(shimmerAnim, {
                    toValue: 1,
                    duration: 1500,
                    easing: Easing.linear,
                    useNativeDriver: true,
                }),
                Animated.timing(shimmerAnim, {
                    toValue: 0,
                    duration: 0,
                    useNativeDriver: true,
                }),
            ])
        ).start()
    }, [])

    const shimmerTranslate = shimmerAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [-100, 300],
    })

    const renderSkeletonItem = (index) => (
        <View key={index} style={styles.skeletonItem}>
            <View style={styles.iconPlaceholder}>
                <View style={styles.shimmerContainer}>
                    <Animated.View
                        style={[
                            styles.shimmer,
                            {
                                transform: [{ translateX: shimmerTranslate }],
                            },
                        ]}
                    />
                </View>
            </View>
            {!collapsed && (
                <View style={styles.textPlaceholder}>
                    <View style={styles.shimmerContainer}>
                        <Animated.View
                            style={[
                                styles.shimmer,
                                {
                                    transform: [{ translateX: shimmerTranslate }],
                                },
                            ]}
                        />
                    </View>
                </View>
            )}
        </View>
    )

    return (
        <View style={styles.container}>
            {Array.from({ length: itemCount }).map((_, index) => renderSkeletonItem(index))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingVertical: 12,
    },
    skeletonItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 16,
        paddingHorizontal: 16,
        marginBottom: 4,
    },
    iconPlaceholder: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: theme.colors.backgroundSecondary || '#F0F0F0',
        overflow: 'hidden',
        marginRight: 12,
    },
    textPlaceholder: {
        flex: 1,
        height: 16,
        borderRadius: 8,
        backgroundColor: theme.colors.backgroundSecondary || '#F0F0F0',
        overflow: 'hidden',
    },
    shimmerContainer: {
        ...StyleSheet.absoluteFillObject,
        overflow: 'hidden',
    },
    shimmer: {
        width: '30%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
})

export default WebSidebarSkeleton
